import { render, staticRenderFns } from "./KPITable.vue?vue&type=template&id=01d15ecc&"
import script from "./KPITable.vue?vue&type=script&lang=js&"
export * from "./KPITable.vue?vue&type=script&lang=js&"
import style0 from "./KPITable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports